export default "__VITE_ASSET__Bx$cEIqK__"